import React, { useEffect, useMemo, useState } from 'react';
import T from 'i18n';
import { useSelector } from 'react-redux';
import { Modal } from 'features/common/MaterialBasedComponents';
import { Spinner } from 'features/common';
import { selectTakeReferenceWithNamesPending } from '../../redux/selectors';

const ModalTakeReferenceWithNames = ({ show, handleClose, handleSave, action, selectedRows }) => {
  const [loading, setLoading] = useState(false);
  const takeReferenceWithNamesPending = useSelector(selectTakeReferenceWithNamesPending);
  const hasSelection = Boolean(selectedRows && selectedRows.length);

  const onSave = () => {
    if (!hasSelection) return;
    setLoading(true);
    handleSave(null, action, selectedRows, null, () => {}, setLoading);
  };

  useEffect(() => {
    if (!takeReferenceWithNamesPending) {
      setLoading(false);
    }
  }, [takeReferenceWithNamesPending]);

  const body = useMemo(() => {
    if (!hasSelection) return T.translate('generic.noFilesSelected');
    if (loading || takeReferenceWithNamesPending) return <Spinner />;
    return T.translate('case.takeReferenceWithNamesDescription');
  }, [hasSelection, loading, takeReferenceWithNamesPending]);

  return (
    <Modal
      show={show}
      title={T.translate('generic.takeReferenceWithNames')}
      handleClose={handleClose}
      handleSave={onSave}
      disableSave={loading || takeReferenceWithNamesPending || !hasSelection}
      saveTitle={T.translate('generic.takeReferenceWithNames')}
    >
      {body}
    </Modal>
  );
};

export default ModalTakeReferenceWithNames;
